<template>
    <div class="messageIcon" :data-note="'消息图标，每' + refreshDelay + 's刷新数据'" style="width: 44px; padding-top: 7px;">
        <router-link class="fl relative" to="/me/message">
            <i class="icon bellIcon size24"></i>

            <!-- 1位数时显示正圆-->
            <span class="remindRedPoint white f10 size12" style="position: absolute; z-index: 2;
                margin-top: -4px; margin-left: -6px;
                border-radius: 6px;
                line-height: 12px;" v-if="newMessageCount > 0 && newMessageCount < 10">{{newMessageCount}}</span>
            <!-- 2位数以上时显示椭圆-->
            <span class="remindRedPoint white f10" style="position: absolute; z-index: 2;
                margin-top: -4px; margin-left: -6px; width: auto; height: 12px;
                padding: 0 2px; border-radius: 6px;
                line-height: 12px; " v-if="newMessageCount >= 10">{{newMessageCount}}+</span>
        </router-link>
    </div>
</template>

<script>
import timerManager from "@/components/platformApi/timerManager";
import userApi from '@/api/user';
import appHelper from "@util/appHelper";
import consoleApi from "@comp/platformApi/consoleApi";

const config = {
    // unit: second
    refreshDelay : 10
}

export default {
    name: "messageIcon",
    data() {
        return {
            newMessageCount : 0,
            timer : null,
            refreshDelay : config.refreshDelay,

            loginStatus : false
        }
    },
    methods : {
        updateData() {
            const me = this;
            if (!this.loginStatus)
            {
                return;
            }
            userApi.getUserNewMessageCount((data) => {
                console.log(data);
                me.newMessageCount = data;
            });
        }
    },
    mounted() {
        const me = this;

        me.updateData();
        this.timer = timerManager.setInterval(() => {
            me.updateData();
        }, config.refreshDelay * 1000);

        appHelper.checkLogin((error, result) => {

            consoleApi.log('[messageIcon] check login callback');

            if (error) {
                return;
            }

            if (!result)   // 游客
            {
                consoleApi.log('result: ', result);
                return;
            }

            me.loginStatus = true;

        });

    },
    destroyed() {
        timerManager.clearInterval(this.timer);
    }
}
</script>

<style lang="scss" scoped>
.bellIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADrElEQVRoge2YT2hURxzHH0RL/AMptCgelId5WwNvs773+/4mYUuVLUIhpGqIXbDRxoOiLRTpNZqWtra0aAtCQHsopISyL8SDRQQFD2J7SMCLVNBoSwJVRBSREkmCkUwPbuzs7L7NbjIvL4f9wu80w/f7+c0Ms2/HsiKQDJyMHHTOy8B5LANnRgbOTRkkTsh++/Uo8oxKBs73MnBkSN2TObspbsZQyZzzWRn4/5tYjjsh++16mXOeKqBTctDpk0Fjrwyc2wVNDDYej5u3SPLXxPsFkLnGjldjQ+5aGSTGlfGbcbKWlMw5hxTAmaLxIHFKGZ+Ig7GsZM7ZPwf4z9m35L42vw1AB4AuAO9dP9l0deKXRL6BxHjcvEX6tLO564vuZrnjHZIASpZgyI/aPfnj4eT1lpaWN+JmtizLsjzPexvASBh0mZoAcMK27fq42OsAnFoAuF5/+b6/dUnJbduuB3CxBMwzIhoA0CWE2Dw3P51OryKibcx8jIhuhOzGu0sC77ruawAuawCzAM4AeLMSDwDtAMY1j0nf97dHzW8B+FkLfuT7/o5qfVzXXcvMg5rXU8/z7AiwXyp/LaqBD5h5yyI9z6ieRHTNFK8etJKZx5SwKSJKGfL+TW2CmT8w4auHHNJWv8eUdyqVWgfgX8X7T1Per6Td9Q/T6fQqw/5fqwvkeZ4wZp5foVnlnH5jzDyvZDK5HsDMXIbv+18ZMyeiTnV1ovrhAfC7skhXjBkz8zH1vjZmrAnAD0rOPZPGpxXjO8aMi3M+0S6KlUaMiahPMR01YlpCALJqA62treuNGC9VA8y8R9uBDUaMaw1UqFoDYao1UKFqDYSJiC4pppE9SjHzLrUBItpmwvSIZjpggLWkhBCb1Y9GAGMAGhZsSEQpAFMK/LQQwjXIXCqzXztGQwsyArAawKi2+kcM84bl3lJzmbn63PzziLoSuQh4S4qZkwAmlezq/75q8KOpVGpNRLxh+Qe0Xfi2WoOC5w4iGl/qWmwD01oTcdfnVTVARD8tA+i5mgDQWFUD2Wy2jpkPEtGX8xWAYSXsSZl557RjcbIC717P8xJVwVcrIlL/Mz8LezIH0KPMe5HJZFZEClapmDmjbfl3+hwhxEYAj5Q5f8TBGqY6IrqrNkFEfUIIF0ADM+8F8Ld2fLrjhi4QEe1E4XdMuRq2LKsubuYiAfgYwPN54EeMvTZEIWZOMvOFEuD3ARyFqbeeqAVgEzPvZuYPfd/fns1ml9+RqcmA/gOnjoeDbeKYLgAAAABJRU5ErkJggg==');
}
</style>
